import script from "./cardType.vue?vue&type=script&setup=true&lang=js"
export * from "./cardType.vue?vue&type=script&setup=true&lang=js"

import "./cardType.vue?vue&type=style&index=0&id=23cca7b3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23cca7b3"]])

export default __exports__